import '../styles/Home.css';
import gh from "../Assets/Game View/Gameplay-Home.png";
import React from "react";


// description images
const descriptionImages = {
    about: require("../Assets/Images/Description Images/about.png"),
    person: require("../Assets/Images/Description Images/person.png"),
    customize: require("../Assets/Images/Description Images/customize.png"),
    stream: require("../Assets/Images/Description Images/stream.png"),
    ragstoriches: require("../Assets/Images/Description Images/async multiplayer.png"),
    multiplayer: require("../Assets/Images/Description Images/real-time multiplayer.png"),
};

const gameScreenshots_UI = {
    blank: require("../Assets/Website Pack/UI/Blank Fullscreen.png"),
    comingsoon: require("../Assets/Website Pack/UI/Coming Soon.png"),
    healthsafety: require("../Assets/Website Pack/UI/Health And Safety.png"),
    leaderboard: require("../Assets/Website Pack/UI/Leaderboard.png"),
};

const gameScreenshots_game = {
    blockpreview: require("../Assets/Website Pack/Gameplay/Dynamic Playstyle.png"),
    tutorial: require("../Assets/Website Pack/Gameplay/Tutorial Screenshot.png"),
    somanyshaders: require("../Assets/Website Pack/Gameplay/Stream Editor.png"),
};

const otherAssets = {
    square: require("../Assets/Website Pack/Square.png"),
    steamBig: require("../Assets/Website Pack/Steam Wallpaper.jpg"),
};

function Home() {
    // Function to handle arrow click event
    const handleArrowClick = () => {
        // Example: Scroll to "about-section"
        document.getElementById("about").scrollIntoView({ behavior: "smooth"});
    };

    return (
        <div>

            <div className="image-container">
                <iframe
                    className="goResponsive homescreen-image"
                    src="https://player.vimeo.com/video/1210596195?background=1"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    title="Poly Beats Trailer"
                    style={{pointerEvents: "none"}}
                ></iframe>
            </div>

            <div className="gameframe-container">

                <iframe src="https://store.steampowered.com/widget/2734590/" frameBorder="0"
                        width="720" height="200"></iframe>
                <p style={{color: 'white', fontSize: '3.45vh', textAlign: 'center', fontWeight: 'bold'}}>
                    PLAYTEST NOW ON STEAM.
                </p>
            </div>


            <div className="goResponsive-pos text-container">
                <p style={{color: 'white', fontSize: '3.45vh'}}>
                    ABOUT POLY BEATS
                    <div className="goResponsive-pos arrow" onClick={handleArrowClick}></div>
                </p>
            </div>

            <div id="About Poly Beats">
                {/* A New Contender To The Rhythm Game Space */}

                <div className="about-frame">
                    <div>
                        <img src={descriptionImages.about} alt="About Poly Beats"
                             className="header-image"/>
                    </div>
                    <div id="about">
                        <p className="no-wrap">A NEW CONTENDER TO THE RHYTHM GAME SPACE.</p>
                    </div>
                    <span className="normal-text"> Welcome to Poly Beats, the 5K Rhythm Game that's all about fun over competition and difficulty, though we do have a ton of that anyways. </span>

                    <img className="divider" src={otherAssets.square} alt="Divider"/> {/* Divider image */}
                </div>

                {/* What Even Is A "5K Rhythm Game"? */}
                <div className="about-frame">
                    <div id="What Even Is A 5K Rhythm Game">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <div id="about">
                                    <p className="no-wrap">"WHAT EVEN IS A 5K RHYTHM GAME"?</p>
                                    <img style={{height: "75px", width: "75px"}} src={descriptionImages.person}
                                         alt="Person"/>
                                </div>

                                <div className="about-text-container">
                                    <img
                                        src={gameScreenshots_game.tutorial}
                                        alt="Chewtorial"
                                        className="screenshot-image"
                                    />
                                    <span className="normal-text">
                    You may be asking.
                    <br/><br/> Well, a rhythm game is a game where you do something to the beat, or, <i>rhythm</i> of the music, your goal is to stay as parallel (similar) as possible to the timing.
<br/><br/> In our case, our game is 5K - which means you have 5 inputs that could be tested for your accuracy at any given moment in a song.
                </span>


                                </div>

                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Customize... Everything? */}
                <div className="about-frame">
                    <div id="Customize Everything">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <div><img src={descriptionImages.customize}
                                          alt="Workshop" className="header-image"/></div>
                                <div id="about">
                                    <p className="no-wrap">CUSTOMIZE EVERYTHING.</p>
                                </div>

                                <div className="about-text-container">

                                        <span className="normal-text">
                    We were all about making Poly Beats tailor to you from the start.
                                            <br/><br/>Personalize your experience with custom keybinds, maps, colors, and note effects.
                                            <br/><br/>But we're not stopping there – dive into the world of Steam Workshop, where players worldwide can effortlessly share and access custom maps and themes.
                </span>
                                    <img
                                        src={otherAssets.steamBig}
                                        alt="Steam Big"
                                        className="screenshot-image"
                                    />

                                </div>

                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Decorations In Every Official Level */}
                <div className="about-frame">
                    <div id="Decorations In Every Official Level">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <div><img src={descriptionImages.stream}
                                          alt="stream" className="header-image"/></div>
                                <div id="about">
                                    <p className="no-wrap">DECORATIONS IN EVERY OFFICIAL LEVEL.</p>
                                </div>

                                <div className="about-text-container">
                                    <img
                                        src={gameScreenshots_game.somanyshaders}
                                        alt="SMS"
                                        className="screenshot-image"
                                    />
                                    <span className="normal-text">
                    For our casual players, we've got something special – Stream! Our in-house decoration system & runtime option, that lets map creators go wild with decorations, like shapes, light rays, and custom shaders!
<br/><br/>
Plus, it's super easy with our in-game Decoration Editor. Just lay down the original Chart-Map (which is where all the notes to your level are stored), and we're good to go!</span>


                                </div>

                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Innovative Gamemodes */}
                <div className="about-frame">
                    <div id="Innovative Gamemodes">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <div><img src={descriptionImages.ragstoriches}
                                          alt="Rags to Riches" className="header-image"/></div>
                                <div id="about">
                                    <p className="no-wrap">INNOVATIVE GAMEMODES.</p>
                                </div>

                                <div className="about-text-container">

                                        <span className="normal-text">
Check out our 'Rags To Riches' gamemode. It's an asynchronous multiplayer mode where you can
                                            <br></br>receive maps from other players to be better than them at, or to send and see who's really the better player at Poly Beats.
<br/><br/>
   It's ranked, by the way - so you can move up ranks, scaling from Trisa to Octa. Are you good enough? :p</span>
                                </div>

                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Multiplayer */}
                <div className="about-frame">
                    <div id="Normal Multiplayer">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <div><img src={descriptionImages.multiplayer}
                                          alt="Rags to Riches" className="header-image"/></div>
                                <div id="about">
                                    <p className="no-wrap">+ 'NORMAL' MULTIPLAYER.</p>
                                </div>

                                <div className="about-text-container">

                                        <span className="normal-text">
                                            The multiplayer you probably expect for a rhythm game - but with a twist.
                                            <br></br>
                                             Instead of having standard modifiers available... how about some gamemodes instead?
<br/><br/>
Think... Tug of War, Free For All with power-ups and abilities, World Repair in Co-Op and... way more? :)</span>
                                </div>

                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Tune Packs, Collabs, More Content */}
                <div className="about-frame">
                    <div id="Tune Packs, Collabs, More Content">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <div id="about">
                                    <p className="no-wrap">OFFICIAL CONTENT REGULARLY.</p>
                                </div>

                                <div className="about-text-container">

                                        <span className="normal-text">
                                            We want to actually consistently give songs to our community, <i>unlike another game... where you rely on only the community after the tutorial. </i>
                                            <br/><br/> We intend to make official OSTs for all our players who regularly want new challenges, alongside a couple collabs with artists both over and underground here and there. </span>
                                    <img
                                        src={gameScreenshots_game.blockpreview}
                                        alt="Blocks"
                                        className="screenshot-image"
                                    />

                                </div>

                                <img className="divider" src={otherAssets.square}
                                     alt="Divider"/> {/* Divider image */}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Get It Now, Fool. */}
                <div className="about-frame">
                    <div id="Get It Now, Fool">
                        <div className="about-frames-container">
                            <div className="about-frame">
                                <br/>
                                <div id="about">

                                    <p style={{color: '#FF6394'}} className="no-wrap">GET IT NOW, FOOL.</p>

                                </div>

                                <div className="about-text-container">
                                       <span className="normal-text">
                    Thanks for reading about our game! If you made it this far, I'm sure you wanna play… so what are you waiting for?
                                           <br/><br/> Wishlist this thing, and we'll catch you on release day! :)
                </span>

                                </div>

                                <br/><br/>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    );
}

export default Home;
